import * as DKFDS from 'dkfds';
import $ from 'jquery';

function deleteVehicles() {
    $('#deleteVehiclesLoading').show();
    $('form').append("<input type='hidden' name='delete' value='1'>").submit();
}

function showModal($modal) {
    const noVehicles = $('input:checked[name=selectedVehicle]').length;
    const vehiclesText = noVehicles === 1 ? ' køretøj' : ' køretøjer';
    $('#deleteVehiclesText').html(`Du er i gang med at slette ${noVehicles}${vehiclesText}.`);
    $('#deleteVehiclesModalOK').one('click', deleteVehicles);
}

function onClick() {
    const noVehicles = $('input:checked[name=selectedVehicle]').length;
    if (noVehicles === 0) {
        new DKFDS.Toast(document.getElementById('deleteVehiclesError')).show();
    }
    else {
        new DKFDS.Modal(document.getElementById('deleteVehiclesModal')).show();
    }
}

$(() => {
    const $modal = $('#deleteVehiclesModal');

    $('#btnDeleteVehiclesModal').on('click', onClick);
    $modal.get(0).addEventListener('fds.modal.shown', () => showModal($modal))
});
